// // src/components/Forms/EditItemForm.js
// import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
// import { toast } from "react-toastify";

// const EditItemForm = ({ item, onUpdate, onClose }) => {
//   const [formData, setFormData] = useState({
//     _id: "",
//     name: "",
//     category: "",
//     count: 0,
//     shortDescription: "",
//     instructions: "",
//   });

//   // This useEffect ensures the form state is updated whenever the 'item' prop changes.
//   useEffect(() => {
//     if (item) {
//       setFormData({
//         _id: item._id || "",
//         name: item.name || "",
//         category: item.category || "",
//         count: item.count || 0,
//         shortDescription: item.shortDescription || "",
//         instructions: item.instructions || "",
//       });
//     }
//   }, [item]);

//   const handleInputChange = (e) => {
//     const { name, value, type } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: type === "number" ? Number(value) : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await onUpdate(formData);
//       // The success toast is now handled by the parent component (Tables.js)
//     } catch (error) {
//       console.error("Failed to update item:", error);
//       toast.error("Failed to update item.");
//     }
//   };

//   return (
//     <>
//       <div className="relative flex flex-col min-w-0 break-words w-full shadow-lg rounded-lg bg-blueGray-100 border-0">
//         <div className="rounded-t bg-white mb-0 px-6 py-6">
//           <div className="text-center flex justify-between">
//             <h6 className="text-blueGray-700 text-xl font-bold">Edit Item</h6>
//             <button
//               className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
//               type="submit"
//               onClick={handleSubmit}
//             >
//               Save
//             </button>
//           </div>
//         </div>
//         <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
//           <form onSubmit={handleSubmit}>
//             {/* Item Information Section */}
//             <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
//               Item Information
//             </h6>
//             <div className="flex flex-wrap">
//               <div className="w-full lg:w-6/12 px-4">
//                 <div className="relative w-full mb-3">
//                   <label htmlFor="name" className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Item Name</label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
//                     value={formData.name}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//               <div className="w-full lg:w-6/12 px-4">
//                 <div className="relative w-full mb-3">
//                   <label htmlFor="category" className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Category</label>
//                   <input
//                     type="text"
//                     id="category"
//                     name="category"
//                     className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
//                     value={formData.category}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//               <div className="w-full lg:w-6/12 px-4">
//                 <div className="relative w-full mb-3">
//                   <label htmlFor="count" className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Count</label>
//                   <input
//                     type="number"
//                     id="count"
//                     name="count"
//                     className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
//                     value={formData.count}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//               <div className="w-full lg:w-6/12 px-4">
//                 <div className="relative w-full mb-3">
//                   <label htmlFor="shortDescription" className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Short Description</label>
//                   <textarea
//                     id="shortDescription"
//                     name="shortDescription"
//                     className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
//                     value={formData.shortDescription}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//             </div>

//             <hr className="mt-6 border-b-1 border-blueGray-300" />
            
//             {/* Instructions Section */}
//             <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
//               Instructions
//             </h6>
//             <div className="flex flex-wrap">
//               <div className="w-full lg:w-12/12 px-4">
//                 <div className="relative w-full mb-3">
//                   <label htmlFor="instructions" className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Instructions</label>
//                   <textarea
//                     id="instructions"
//                     name="instructions"
//                     className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
//                     value={formData.instructions}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="flex justify-end mt-6">
//               <button
//                 className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
//                 type="button"
//                 onClick={onClose}
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// EditItemForm.propTypes = {
//   item: PropTypes.object,
//   onUpdate: PropTypes.func.isRequired,
//   onClose: PropTypes.func.isRequired,
// };

// export default EditItemForm;
// src/components/Forms/EditItemForm.js
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import ReactQuill from 'react-quill'; // Import ReactQuill
import 'react-quill/dist/quill.snow.css'; // Import the stylesheet

const EditItemForm = ({ item, onUpdate, onClose }) => {
  const [formData, setFormData] = useState({
    _id: "",
    name: "",
    category: "",
    count: 0,
    shortDescription: "",
    instructions: "",
  });

  const [isSaving, setIsSaving] = useState(false);

  // This useEffect ensures the form state is updated whenever the 'item' prop changes.
  useEffect(() => {
    if (item) {
      setFormData({
        _id: item._id || "",
        name: item.name || "",
        category: item.category || "",
        count: item.count || 0,
        shortDescription: item.shortDescription || "",
        instructions: item.instructions || "",
      });
    }
  }, [item]);

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? Number(value) : value,
    }));
  };

  // Dedicated handler for the ReactQuill editor
  const handleInstructionsChange = (content) => {
    setFormData((prevData) => ({
      ...prevData,
      instructions: content,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    try {
      await onUpdate(formData);
      // The success toast is handled by the parent component (Tables.js)
    } catch (error) {
      console.error("Failed to update item:", error);
      toast.error("Failed to update item.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      {/* Local styles to override Quill's default appearance, copied from CardAddItem */}
      <style>{`
        .ql-container.ql-snow {
            border: 0;
        }
        .ql-toolbar.ql-snow {
            background-color: #f3f4f6;
            border-bottom: 1px solid #e2e8f0;
            border-radius: 0.25rem 0.25rem 0 0;
        }
        .ql-editor {
            background-color: white;
            min-height: 150px;
        }
      `}</style>
      <div className="relative flex flex-col min-w-0 break-words w-full shadow-lg rounded-lg bg-blueGray-100 border-0">
        <div className="rounded-t bg-white mb-0 px-6 py-6">
          <div className="text-center flex justify-between">
            <h6 className="text-blueGray-700 text-xl font-bold">Edit Item</h6>
            <button
              className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
              type="submit"
              onClick={handleSubmit}
              disabled={isSaving}
            >
              {isSaving ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
        <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
          <form onSubmit={handleSubmit}>
            {/* Item Information Section */}
            <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
              Item Information
            </h6>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label htmlFor="name" className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Item Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={formData.name}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              
              {/* CATEGORY: CHANGED TO DROPDOWN */}
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label 
                    htmlFor="category" 
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                  >
                    Category
                  </label>
                  <select
                    name="category"
                    id="category"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={formData.category}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Category</option>
                    <option value="Consumable">Consumable</option>
                    <option value="Non-consumable">Non-consumable</option>
                  </select>
                </div>
              </div>

              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label htmlFor="count" className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Count</label>
                  <input
                    type="number"
                    id="count"
                    name="count"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={formData.count}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label htmlFor="shortDescription" className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Short Description</label>
                  <textarea
                    id="shortDescription"
                    name="shortDescription"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={formData.shortDescription}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            <hr className="mt-6 border-b-1 border-blueGray-300" />
            
            {/* INSTRUCTIONS SECTION: CHANGED TO REACTQUILL */}
            <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
              
            </h6>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-12/12 px-4">
                <div className="relative w-full mb-3">
                  <label 
                    htmlFor="instructions" 
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                  >
                    Instructions
                  </label>
                  <div className="border-0 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full">
                    <ReactQuill
                      theme="snow"
                      value={formData.instructions}
                      onChange={handleInstructionsChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-end mt-6">
              <button
                className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                type="button"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

EditItemForm.propTypes = {
  item: PropTypes.object,
  onUpdate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EditItemForm;